import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";

import { Dispatcher, Constants } from "../../../flux";

class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR
    });
  }

  render() {
    const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
          style={{
            boxShadow: '0 1px 10px rgba(0,0,0,0.05)',
            borderBottom: '1px solid #eaedf3'
          }}
        >
          <NavbarBrand
            className="w-100 mr-0"
            href="/"
            style={{ 
              backgroundColor: '#FFFFFF',
              padding: '0.5rem 1rem',
              transition: 'all 0.2s ease'
            }}
          >
            <div className="d-table m-auto">
              <img
                id="main-logo"
                className="d-inline-block align-top mr-1"
                src={require("../../../images/enforceplus-long.png")}
                style={{
                  maxWidth: 172, 
                  maxHeight: 45,
                  transition: 'opacity 0.2s ease'
                }}
                alt="EnforcePlus Admin"
              />
            </div>
          </NavbarBrand>
          {/* eslint-disable-next-line */}
          <a
            className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
            onClick={this.handleToggleSidebar}
            style={{
              padding: '1rem',
              color: '#495057',
              transition: 'color 0.2s ease, background-color 0.2s ease'
            }}
          >
            <i className="material-icons">&#xE5C4;</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false
};

export default SidebarMainNavbar;
